import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Button } from 'components/Form/Button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TemplateColumn } from '../../hooks/useDownloadTemplate';

export type TemplateDownloaderProps = {
  columns: Array<TemplateColumn>;
  partnerName: string;
  updatedAt: string | undefined;
  onDownload: () => void;
  isDownloading: boolean;
};

export const TemplateDownloader: FC<TemplateDownloaderProps> = ({ partnerName, onDownload, isDownloading }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <Button
        LeftIcon={ArrowDownTrayIcon}
        loading={isDownloading}
        analyticsId="webedi:pricat_dowload_template"
        variant="secondary"
        onClick={onDownload}
      >
        {t('priceCatalogs:uploadModal.downloadTemplate.button', {
          partnerName: partnerName.length > 25 ? `${partnerName.substring(0, 25)}...` : partnerName,
        })}
      </Button>
    </div>
  );
};
